import { render } from "./WhatsNew.vue?vue&type=template&id=0e7b3f17&scoped=true"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"

import "./WhatsNew.vue?vue&type=style&index=0&id=0e7b3f17&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7b3f17"]])

export default __exports__